import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFileChart: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconFileChart"><Path fillRule="evenodd" clipRule="evenodd" d="M4 2H12V10H20V22H4V2ZM14 2.58579L19.4142 8H14V2.58579ZM9.5 15.5H7.5V19H9.5V15.5ZM13 12.5V19H11V12.5H13ZM16.5 14.5H14.5V19H16.5V14.5Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFileChart;
